import { render, staticRenderFns } from "./LoansList.vue?vue&type=template&id=59972ce6&scoped=true&"
import script from "./LoansList.vue?vue&type=script&lang=js&"
export * from "./LoansList.vue?vue&type=script&lang=js&"
import style0 from "./LoansList.vue?vue&type=style&index=0&id=59972ce6&lang=scss&scoped=true&"
import style1 from "./LoansList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59972ce6",
  null
  
)

export default component.exports